import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import type { Product, ProductFamily } from '../types';
import CbButton from '../../../components/Buttons/CbButton';

interface ProductReplacementModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  selectedProduct: Product | null;
  existingProduct: Product | null;
  productFamily: ProductFamily | null;
}

const ProductReplacementModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  selectedProduct,
  existingProduct,
  productFamily,
}: ProductReplacementModalProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          m: 2,
          borderBottom: 'none',
        }}
      >
        <Typography variant="body1">Confirm Product Replacement</Typography>
      </DialogTitle>
      <DialogContent sx={{ m: 2, p: 0, mt: 0, border: 'none' }}>
        <DialogContentText>
          <Typography variant="body2">
            A product from this product family is already in your cart. Do you
            want to replace it with the selected product? The existing item will
            be removed.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ borderTop: 'none', pt: 0 }}>
        <CbButton size="medium" onClick={onClose} variant="outlined">
          Cancel
        </CbButton>
        <CbButton
          styleName="ctaButton"
          size="medium"
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <CircularProgress size={20} sx={{ mr: 1 }} />
              Replacing...
            </>
          ) : (
            'Replace Product'
          )}
        </CbButton>
      </DialogActions>
    </Dialog>
  );
};

export default ProductReplacementModal;
